import { action, makeObservable, observable } from "mobx";
import { observer } from "mobx-react-lite";
import { Button, ButtonTypes } from "../../../components/ui/Button";
import I18n from "../../localization/I18n";
import { IBaseReportFilterAddon, ReportFilterAddonsKeys } from "../ReportFilterAddon";
import { ReportFilterModel } from "../ReportFilter_model";
import { SHOW_TAGS_SIDEBAR } from "../../modalZ/common/TagsSidebarView/TagsSidebar_modals";

export class TagReportFilterAddon implements IBaseReportFilterAddon {
  key: string = ReportFilterAddonsKeys.Tags;
  @observable selectedIds: number[] = [];
  reportFilterModel: ReportFilterModel;
  @observable data: FP.Entities.ITag[] = [];

  constructor(reportFilterModel: ReportFilterModel, currentFilter: any) {
    makeObservable(this);
    this.setSelectedIds(currentFilter || []);
    this.reportFilterModel = reportFilterModel;
    this.data = reportFilterModel.data[this.key];
  }

  clearSelectedIds = () => {
    this.setSelectedIds([]);
  };

  render = () => {
    return <ButtonArea key={this.key} model={this} />;
  };

  displayModal = () => {
    SHOW_TAGS_SIDEBAR(this.getQueryJSON, this.selectedIds, this.data);
  };

  getQueryJSON = (tagIds: number[]) => {
    this.setSelectedIds(tagIds);
    this.reportFilterModel.generateQueryJson();
    return {
      [this.key]: this.selectedIds
    };
  };

  getSelectedIds = () => {
    return this.selectedIds;
  };

  @action
  setSelectedIds = (selectedIds: number[]) => (this.selectedIds = selectedIds);
}

const ButtonArea: React.FC<{ model: TagReportFilterAddon }> = observer(({ model }) => {
  return (
    <Button key={model.key} className="px-2" type={ButtonTypes.LINK} onClick={model.displayModal}>
      {I18n.t("entities.tags") + " "}
      {model.selectedIds.length > 0 ? (model.selectedIds.length < 10 ? `(${model.selectedIds.length})` : "9+") : ""}
    </Button>
  );
});
